import deepOrange from '@material-ui/core/colors/deepOrange';
import grey from '@material-ui/core/colors/grey';

const brandPrimary = deepOrange[500];
const brandPrimaryHover = deepOrange[700];
const brandInactive = grey[500];
const brandInactiveDark = grey[700];
const brandBorder = grey[400];

export default {
  palette: {
    primary: {
      light: deepOrange[300],
      main: brandPrimary,
      dark: deepOrange[700],
      contrastText: '#fff'
    },
    secondary: {
      light: grey[300],
      main: grey[500],
      dark: grey[700],
      contrastText: '#212121'
    }
  },
  status: {
    danger: 'orange',
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        backgroundColor: brandPrimary,
        '&:hover': {
          backgroundColor: brandPrimaryHover
        }
      },
      outlinedPrimary: {
        color: brandPrimary,
        borderColor: brandPrimary,
        '&:hover': {
          borderColor: brandPrimaryHover,
          backgroundColor: 'rgba(255, 87, 34, 0.08)'
        }
      }
    },
    MuiFormLabel: {
      root: {
        color: brandInactive,
        '&$focused': {
          color: brandPrimary
        }
      },
      focused: {}
    },
    MuiInputLabel: {
      shrink: {
        transform: 'translate(0, 1.5px) scale(0.75)'
      },
      outlined: {
        transform: 'translate(14px, 14px) scale(1)',
        '&$shrink': {
          transform: 'translate(14px, -6px) scale(0.75)'
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 6,
        backgroundColor: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: brandBorder
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: brandInactiveDark
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: brandPrimary
        }
      },
      input: {
        padding: '11px 14px',
        lineHeight: '20px'
      },
      inputMultiline: {
        padding: '10px 14px'
      }
    },
    MuiInputBase: {
      input: {
        '&::placeholder': {
          color: brandInactive,
          opacity: 1
        }
      }
    },
    MuiFormHelperText: {
      root: {
        '&:not(.Mui-error)': {
          color: brandInactive
        }
      }
    },
    MuiTab: {
      textColorPrimary: {
        color: brandInactive,
        '&$selected': {
          color: brandPrimary
        }
      }
    },
    MuiTabs: {
      indicator: {
        backgroundColor: brandPrimary
      }
    },
    MuiCheckbox: {
      colorPrimary: {
        color: brandInactive,
        '&$checked': {
          color: brandPrimary
        }
      }
    },
    MuiRadio: {
      colorPrimary: {
        color: brandInactive,
        '&$checked': {
          color: brandPrimary
        }
      }
    },
    MuiSwitch: {
      colorPrimary: {
        color: brandInactive,
        '&$checked': {
          color: brandPrimary,
          '& + $track': {
            backgroundColor: brandPrimary
          }
        }
      },
      track: {
        backgroundColor: grey[400],
        opacity: 1
      }
    }
  },
  typography: {
    button: {
      fontWeight: 400,
      textAlign: 'capitalize'
    },
  },
};
